var map = {
	"./chromealive/Example.vue": [
		3041,
		849,
		926
	],
	"./cloud/Example.vue": [
		7241,
		849,
		155
	],
	"./datastore/Example.vue": [
		7363,
		849,
		512
	],
	"./hero/Example.vue": [
		9377,
		849,
		556
	],
	"./stream/Example.vue": [
		8831,
		914
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2046;
module.exports = webpackAsyncContext;